import {
  Box,
  Heading,
  VStack,
  Text,
  Badge,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { Rock, User } from '../../types';
import { Card } from '../../../../components/Card';

interface ActiveRocksListProps {
  rocks: Rock[];
  users: User[];
}

/**
 * Active Rocks List Component
 * Shows active rocks with status and progress
 */
export function ActiveRocksList({ rocks, users }: ActiveRocksListProps) {
  const headingColor = useColorModeValue('gray.900', 'white');
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'on-track':
        return 'green';
      case 'off-track':
        return 'red';
      default:
        return 'gray';
    }
  };

  const getUserName = (userId: string) => {
    const user = users.find((u) => u.id === userId);
    return user?.name || 'Unknown';
  };

  if (rocks.length === 0) {
    return (
      <Card borderWidth="1px" borderColor={borderColor}>
        <Heading size="md" mb={4} color={headingColor}>
          Active Rocks
        </Heading>
        <Text color={textColor}>No active rocks for this period</Text>
      </Card>
    );
  }

  return (
    <Card borderWidth="1px" borderColor={borderColor}>
        <Heading size="md" mb={4} color={headingColor}>
          Active Rocks ({rocks.length})
        </Heading>
        <VStack spacing={3} align="stretch">
          {rocks.map((rock) => (
            <Box
              key={rock.id}
              p={3}
              borderRadius="md"
              borderWidth="1px"
              borderColor={borderColor}
            >
              <HStack justify="space-between" mb={2}>
                <Text fontWeight="medium" color={headingColor} noOfLines={1}>
                  {rock.rock}
                </Text>
                <Badge colorScheme={getStatusColor(rock.status)}>
                  {rock.status.replace('-', ' ')}
                </Badge>
              </HStack>
              <HStack spacing={2} fontSize="sm" color={textColor}>
                <Text>Owner: {getUserName(rock.ownerId)}</Text>
                <Text>•</Text>
                <Text>Progress: {rock.progress || 0}%</Text>
              </HStack>
            </Box>
          ))}
        </VStack>
    </Card>
  );
}

